import { render, staticRenderFns } from "./dialogComponent.vue?vue&type=template&id=2198edc5"
import script from "./dialogComponent.vue?vue&type=script&lang=js"
export * from "./dialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports